import { useEffect, useContext } from "react";

import PermissionContext from "../../../context/PermissionContext";
import DrawerContext from "../../../context/DrawerContext";
import AutoLogout from "../../../utils/useAutoLogout";
import PayloadPhaseContext from "../../../context/materialcapture/PayloadPhaseContext";

import SideDrawer from "../../../components/layout/SideDrawer";
import SuccessAlert from "../../../components/layout/SuccessAlert";
import Loader from "../../../components/layout/Loader";
import ErrorModal from "../../../components/layout/ErrorModal";
import TopBarWithBack from "../../../components/layout/TopBarWithBack";
import PayloadPhaseForm from "../../../components/materialscapture/PayloadPhaseForm";

const PayloadPhaseEditPage = () => {
  const { permisionsList, checkUserPermission } = useContext(PermissionContext);
  const { drawerValue, setDrawerValue } = useContext(DrawerContext);
  const { apiRes, setApiRes, setPayloadPhaseId } = useContext(PayloadPhaseContext);

  const backURL = '/payload-phase';

  useEffect(() => {
    if(permisionsList.length > 0) checkUserPermission(['Materials Capture-Payload Phase']);
  }, [permisionsList]);

  useEffect(() => {
    const docUrIArr = window.location.href.split('/');
    setPayloadPhaseId(docUrIArr[docUrIArr.length - 1]);
  }, []);

  return(
    <AutoLogout>
      <SideDrawer drawerValue={drawerValue} setDrawerValue={setDrawerValue} />
      {apiRes.loading && <Loader />}
      <div className="mainContainer" style={{ marginLeft: drawerValue.drawerWidth }}>
        {apiRes.showAlert && <SuccessAlert apiRes={apiRes} setApiRes={setApiRes} />}
        <TopBarWithBack title={'Payload Phase Edit'} backURL={backURL} />
        <PayloadPhaseForm />

        <ErrorModal apiRes={apiRes} setApiRes={setApiRes} />
      </div>
    </AutoLogout>
  );
};

export default PayloadPhaseEditPage;